var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "searchBar" },
    [
      _c("autocomplete", {
        ref: "searchBar",
        attrs: {
          submitOnEtner: true,
          "get-result-value": _vm.getResultValue,
          search: _vm.search,
          "debounce-time": 100,
        },
        on: { submit: _vm.handleSubmit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }